module.exports = __webpack_public_path__ + "fonts/font.c341059.woff";